import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'comments-confirm-dialog.delete-comment-heading': {
    id: 'comments-confirm-dialog.delete-comment-heading',
    defaultMessage: 'Do you want to delete this comment?',
    description: 'The header of the confirmation dialog for deleting a comment',
  },
  'comments-confirm-dialog.delete-comment-body': {
    id: 'comments-confirm-dialog.delete-comment-body',
    defaultMessage: 'Your comment will be permanently removed if you do.',
    description:
      'The message displayed inside the confirmation dialog for deleting a comment',
  },
  'comments-confirm-dialog.delete-comment-confirm-button': {
    id: 'comments-confirm-dialog.delete-comment-confirm-button',
    defaultMessage: 'Delete',
    description: 'The call to action that will confirm a comment should be deleted',
  },
  'comments-confirm-dialog.delete-comment-cancel-button': {
    id: 'comments-confirm-dialog.delete-comment-cancel-button',
    defaultMessage: 'Cancel',
    description:
      'The button inside of the confirmation dialog for deleting a comment that will cancel the action',
  },
  'comments-snackbar.confirm-resolved-comment': {
    id: 'comments-snackbar.confirm-resolved-comment',
    defaultMessage:
      'Comment was resolved. You can view all comments from the more actions menu.',
    description:
      'The message displayed inside of a snackbar banner when a user resolves a comment',
  },
  'comments-snackbar.undo-resolved-comment': {
    id: 'comments-snackbar.undo-resolved-comment',
    defaultMessage: 'Undo',
    description:
      'The button at the end of the resolved comments snackbar message that lets users undo a resolved comment',
  },
});
